const RecurringShimmer = () => {
    return (
        <div className="col-12 mb-3">
            <div className="card border">
                <div className="card-body p-3 rounded">

                    {/* Top Section */}
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <div>
                            {/* Amount */}
                            <div
                                className="shimmer-wrapper mb-2"
                                style={{ width: '100px', height: '24px', borderRadius: '6px' }}
                            ></div>

                            {/* Badge + Status */}
                            <div className="d-flex align-items-center gap-2 mt-1">
                                <div
                                    className="shimmer-wrapper"
                                    style={{ width: '70px', height: '20px', borderRadius: '20px' }}
                                ></div>
                                <div
                                    className="shimmer-wrapper"
                                    style={{ width: '60px', height: '16px', borderRadius: '6px' }}
                                ></div>
                            </div>
                        </div>

                        {/* Toggle Switch */}
                        <div
                            className="shimmer-wrapper"
                            style={{ width: '40px', height: '20px', borderRadius: '20px' }}
                        ></div>
                    </div>

                    {/* Detail Text */}
                    <div className="mb-3">
                        <div
                            className="shimmer-wrapper mb-1"
                            style={{ width: '90%', height: '12px', borderRadius: '4px' }}
                        ></div>
                        <div
                            className="shimmer-wrapper"
                            style={{ width: '70%', height: '12px', borderRadius: '4px' }}
                        ></div>
                    </div>

                    {/* Bottom Section */}
                    <div className="bg-light rounded-4 p-2 d-flex justify-content-between align-items-center">
                        <div className="ps-2">
                            <div
                                className="shimmer-wrapper mb-1"
                                style={{ width: '90px', height: '10px', borderRadius: '4px' }}
                            ></div>
                            <div
                                className="shimmer-wrapper"
                                style={{ width: '120px', height: '14px', borderRadius: '4px' }}
                            ></div>
                        </div>

                        {/* Action Buttons */}
                        <div className="d-flex gap-1 pe-1">
                            <div
                                className="shimmer-wrapper"
                                style={{ width: '32px', height: '32px', borderRadius: '8px' }}
                            ></div>
                            <div
                                className="shimmer-wrapper"
                                style={{ width: '32px', height: '32px', borderRadius: '8px' }}
                            ></div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default RecurringShimmer;